import React from 'react';
import "react-datepicker/dist/react-datepicker.css";
import swal from "sweetalert";

import OrdenCompraForm from "./OrdenCompraForm";
import { calcularVentaCentimos } from "../../helpers/calcularVenta";
import { EXONERADA, GRAVADA, INAFECTA, TRIBUTO } from '../../Global';

class OrdenCompraEditar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: null,

            data: [],
            dataAlmacenes: [],
            dataMoneda: [],
            objProveedor: [],
            dataDetalleOC: [],
            prod: {},
            form: {
                accion: null,
                modalProveedorIsOpen: false,
                FechaActual: new Date(),
                //datos item seleccionado
                id_SelectSearch: null,
                PrecioCosto: 0.00,
                Cantidad: 0.00,
                IdUnidad: null,
                IdPresentacion: null,
                IdProducto: null,
                respuestaInsert: null,

                inactivo: false,

                IdOrdenCompra: null,
                NroOC: '',
                IdProveedor: null,
                Ruc: '',
                NomProveedor: '',
                NomContacto: '',
                FechaRegistro: new Date(),
                FechaEmision: new Date(),
                FechaEntrega: new Date(),
                IdAlmacen: '0',
                IdMoneda: '1',
                IncluyeIGV: true,
                TipoCambio: 1.0000,
                FormaPago: 'Contado',
                Estado: 'Sin Generar',
                Glosa: '',

                // Valores de DB (ya en céntimos - enteros)
                SubTotal: 0,    // ENTERO (céntimos)
                IGV: 0,         // ENTERO (céntimos) 
                Total: 0,       // ENTERO (céntimos)

                // Valores calculados (en céntimos - enteros)
                vSubTotal: null,
                vIGV: null,
                vTotal: null,
                vExoneradas: null,
                vInafectas: null,
            }
        }
        this.handleEliminarItem = this.handleEliminarItem.bind(this);
        this.recalcularTotalesSiEsNecesario = this.recalcularTotalesSiEsNecesario.bind(this);
    }

    componentDidMount() {
        this.inicio();
    }

    inicio = async () => {
        if (this.props.accion === 'Editar') {
            await this.traerOrdenCompraPorId();
        }
        await this.listaAlmacenes();
        await this.listaMonedas();
        await this.listaDetalleOC();
    }

    calcularTotales(items, incIGV) {
        console.log("=== INICIO cálculo totales ===");
        console.log("Items recibidos:", items);
        console.log("Incluye IGV:", incIGV);
        
        // Si no hay items, establecer valores en 0
        if (!items || items.length === 0) {
            console.log("No hay items, estableciendo valores a 0");
            this.setState({
                form: {
                    ...this.state.form,
                    // Valores calculados EN CÉNTIMOS
                    vSubTotal: 0,
                    vIGV: 0,
                    vTotal: 0,
                    vExoneradas: 0,
                    vInafectas: 0,
                }
            });
            console.log("=== FIN cálculo totales (sin items) ===");
            return;
        }

        let lista = [];

        const GrupoClasificationIgvToTributo = {
            [GRAVADA]: TRIBUTO.IGV,
            [EXONERADA]: TRIBUTO.EXONERADO,
            [INAFECTA]: TRIBUTO.INAFECTO
        };

        if (incIGV) {
            lista = items.map(item => {
                const { Cantidad, PrecioReferencial } = item;
                return ({
                    PrecioVenta: (parseFloat(PrecioReferencial) || 0) / 100,  // Convertir de centavos a soles
                    Tributos: [GrupoClasificationIgvToTributo[item.IdGrupoClasificacionIgv] || TRIBUTO.IGV],
                    TasaISC: 0,
                    Cantidad: parseFloat(Cantidad) || 0,
                    Gratuito: 0,
                    Descuento: 0,
                    IdAfectacionIgv: 1
                });
            });
        } else {
            lista = items.map(item => {
                const { Cantidad, PrecioReferencial } = item;
                return ({
                    ValorUnitario: (parseFloat(PrecioReferencial) || 0) / 100,  // Convertir de centavos a soles
                    Tributos: [GrupoClasificationIgvToTributo[item.IdGrupoClasificacionIgv] || TRIBUTO.IGV],
                    TasaISC: 0,
                    Cantidad: parseFloat(Cantidad) || 0,
                    Gratuito: 0,
                    Descuento: 0,
                    IdAfectacionIgv: 1
                });
            });
        }

        const detalle = { Items: lista };

        console.log("Detalle para calcularVenta:", detalle);
        
        const totalesOC = calcularVentaCentimos(detalle);
        
        console.log("Resultados cálculo (soles):", totalesOC);
        console.log("Gravadas (soles):", totalesOC.Gravadas);
        console.log("Exoneradas (soles):", totalesOC.Exoneradas);
        console.log("Inafectas (soles):", totalesOC.Inafectas);
        console.log("IGV (soles):", totalesOC.IGV);
        console.log("Total (soles):", totalesOC.Total);
        
        // CONVERTIR A CÉNTIMOS
        const toCents = (value) => {
            const cents = Math.round((value || 0) * 100);
            console.log(`Conversión: ${value} soles = ${cents} céntimos`);
            return cents;
        };
        
        const vSubTotalCents = toCents(totalesOC.Gravadas);
        const vIGVCents = toCents(totalesOC.IGV);
        const vTotalCents = toCents(totalesOC.Total);
        
        console.log("Valores finales (céntimos):", {
            vSubTotal: vSubTotalCents,
            vIGV: vIGVCents,
            vTotal: vTotalCents,
            vExoneradas: toCents(totalesOC.Exoneradas),
            vInafectas: toCents(totalesOC.Inafectas)
        });
        
        this.setState({
            form: {
                ...this.state.form,
                vSubTotal: vSubTotalCents,
                vIGV: vIGVCents,
                vTotal: vTotalCents,
                vExoneradas: toCents(totalesOC.Exoneradas),
                vInafectas: toCents(totalesOC.Inafectas),
            }
        });
        
        console.log("=== FIN cálculo totales ===");
    }

    recalcularTotalesSiEsNecesario = () => {
        // Solo recalcular si hay items
        if (this.state.dataDetalleOC.length > 0) {
            this.calcularTotales(this.state.dataDetalleOC, this.state.form.IncluyeIGV);
        }
    }

    handleSubmit = async (e) => {
        if (this.state.form.IdProveedor && this.state.form.IdAlmacen !== '0') {
            if (this.props.accion === 'Nuevo') {
                await this.crearOrdenCompra();
                await this.props.listaOrdenesCompraPorSucursal();
            } else {
                await this.actualizarOrdenCompra();
            }
        } else {
            const r = this.props.accion === 'Nuevo' ? "Crear" : "Actualizar";
            swal({
                title: 'Atención.!',
                text: `No se puede ${r} la Orden de Compra, información incompleta...`,
                icon: 'error'
            });
        }
    };

    traerOrdenCompraPorId = async () => {
        this.setState({loading: true, error: null});
        try {
            const idOrdenCompra = this.props.itemordencompra.idordencompra ?
                this.props.itemordencompra.idordencompra : this.state.form.IdOrdenCompra;

            const response = await fetch(`/api/ordenescompra/item/${idOrdenCompra}`);
            const regoc = await response.json();
            
            console.log("Datos DB recibidos:", regoc[0][0]);
            console.log("Valores DB (céntimos):", {
                SubTotal: regoc[0][0].SubTotal,
                IGV: regoc[0][0].IGV,
                Total: regoc[0][0].Total
            });
            
            this.setState({
                loading: false,
                form: {
                    ...this.state.form,

                    IdOrdenCompra: regoc[0][0].IdOrdenCompra,
                    NroOC: regoc[0][0].Numero,
                    IdProveedor: regoc[0][0].IdProveedor,
                    Ruc: regoc[0][0].RucProveedor,
                    NomProveedor: regoc[0][0].NombreProveedor,
                    NomContacto: regoc[0][0].Contacto || '',
                    FechaEmision: new Date(regoc[0][0].FechaEmision + "T00:00:00.000-05:00"),
                    FechaEntrega: new Date(regoc[0][0].FechaEntrega + "T00:00:00.000-05:00"),
                    IdAlmacen: regoc[0][0].IdAlmacen,
                    IdMoneda: regoc[0][0].IdMoneda,
                    IncluyeIGV: regoc[0][0].IncluyeIGV === 'Si',
                    TipoCambio: parseFloat(regoc[0][0].TipoCambio) || 1.0000,
                    FormaPago: regoc[0][0].FormaPago || 'Contado',
                    Estado: regoc[0][0].Estado,
                    Glosa: regoc[0][0].Glosa || '',
                    
                    // VALORES ORIGINALES DE LA DB (ya están en céntimos)
                    SubTotal: regoc[0][0].SubTotal || 0,
                    IGV: regoc[0][0].IGV || 0,
                    Total: regoc[0][0].Total || 0,
                    
                    // Valores calculados (inicialmente null)
                    vSubTotal: null,
                    vIGV: null,
                    vTotal: null,
                    vExoneradas: null,
                    vInafectas: null,
                }
            });

        } catch (error) {
            this.setState({
                loading: false,
                error: error,
            });
        }
    }

    crearOrdenCompra = async () => {
        try {
            // Usar valores calculados si existen, sino usar valores por defecto
            const subTotalToUse = this.state.form.vSubTotal !== null ? this.state.form.vSubTotal : this.state.form.SubTotal;
            const igvToUse = this.state.form.vIGV !== null ? this.state.form.vIGV : this.state.form.IGV;
            const totalToUse = this.state.form.vTotal !== null ? this.state.form.vTotal : this.state.form.Total;
            
            console.log("Enviando a DB (céntimos):", {
                SubTotal: subTotalToUse,
                IGV: igvToUse,
                Total: totalToUse
            });
            
            const config = {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    IdOrdenCompra: '1',
                    FechaRegistro: this.formatDate(this.state.form.FechaRegistro, 'yyyy-mm-dd'),
                    FechaEmision: this.formatDate(this.state.form.FechaEmision, 'yyyy-mm-dd'),
                    FechaEntrega: this.formatDate(this.state.form.FechaEntrega, 'yyyy-mm-dd'),
                    Serie: this.state.form.Serie,
                    Numero: this.state.form.NroOC,
                    IdMoneda: this.state.form.IdMoneda,
                    TipoCambio: this.state.form.TipoCambio,
                    IdUsuario: 1,
                    IdSucursal: 1,
                    Estado: 'Generada',
                    IdAlmacen: this.state.form.IdAlmacen,
                    Glosa: this.state.form.Glosa,
                    IdProveedor: this.state.form.IdProveedor,
                    FormaPago: this.state.form.FormaPago,
                    IncluyeIGV: this.state.form.IncluyeIGV ? 'Si' : 'No',
                    Contacto: this.state.form.NomContacto,
                    SubTotal: subTotalToUse,
                    IGV: igvToUse,
                    Total: totalToUse,
                })
            };
            
            const response = await fetch(`/api/ordenescompra/add/`, config);
            const rpta = await response.json();

            if (parseInt(rpta.respuesta) !== -1) {
                this.setState({
                    form: {
                        ...this.state.form,
                        IdOrdenCompra: rpta.respuesta,
                    }
                });
                await this.props.cambiarAccion('Editar', rpta.respuesta);
                await this.props.listaOrdenesCompraPorSucursal();
                
                swal({
                    title: 'Atención..!',
                    text: `Se Creó correctamente la Orden de Compra...`,
                    icon: 'success'
                });
            } else {
                swal({
                    title: 'Atención..!',
                    text: `Error al Crear la Orden de Compra...`,
                    icon: 'error'
                });
            }

        } catch (error) {
            this.setState({
                loading: false,
                error: error,
            });
        }
    };

    actualizarOrdenCompra = async () => {
        try {
            // Usar valores calculados si existen, sino usar valores de DB
            const subTotalToUse = this.state.form.vSubTotal !== null ? this.state.form.vSubTotal : this.state.form.SubTotal;
            const igvToUse = this.state.form.vIGV !== null ? this.state.form.vIGV : this.state.form.IGV;
            const totalToUse = this.state.form.vTotal !== null ? this.state.form.vTotal : this.state.form.Total;
            
            console.log("Actualizando en DB (céntimos):", {
                SubTotal: subTotalToUse,
                IGV: igvToUse,
                Total: totalToUse
            });
            
            const config = {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    IdOrdenCompra: this.state.form.IdOrdenCompra,
                    FechaEmision: this.formatDate(this.state.form.FechaEmision, 'yyyy-mm-dd'),
                    FechaEntrega: this.formatDate(this.state.form.FechaEntrega, 'yyyy-mm-dd'),
                    Serie: this.state.form.Serie,
                    Numero: this.state.form.NroOC,
                    IdMoneda: this.state.form.IdMoneda,
                    TipoCambio: this.state.form.TipoCambio,
                    IdUsuario: 1,
                    IdSucursal: 1,
                    Estado: this.state.form.Estado,
                    IdAlmacen: this.state.form.IdAlmacen,
                    Glosa: this.state.form.Glosa,
                    IdProveedor: this.state.form.IdProveedor,
                    FormaPago: this.state.form.FormaPago,
                    IncluyeIGV: this.state.form.IncluyeIGV ? 'Si' : 'No',
                    Contacto: this.state.form.NomContacto,
                    SubTotal: subTotalToUse,
                    IGV: igvToUse,
                    Total: totalToUse,
                })
            };
            
            const res = await fetch(`/api/ordenescompra/update/${this.state.form.IdOrdenCompra}`, config);
            const rpta = await res.json();

            if (parseInt(rpta.respuesta) !== -1) {
                await this.props.listaOrdenesCompraPorSucursal();
                swal({
                    title: 'Atención..!',
                    text: `Se Actualizó correctamente la Orden de Compra...`,
                    icon: 'success'
                });
            } else {
                swal({
                    title: 'Atención..!',
                    text: `Error al Actualizar la Orden de Compra...`,
                    icon: 'error'
                });
            }
            this.props.onClose();

        } catch (error) {
            this.setState({
                loading: false,
                error: error,
            });
        }
    }

    eliminarOrdenCompra = async (id) => {
        try {
            if (id) {
                const response = await fetch(`/api/ordenescompra/delete/${id}`, {
                    method: "DELETE",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    }
                });
                const rpta = await response.json();

                if (rpta) {
                    swal({
                        title: 'Atención...! ',
                        text: `Orden de Compra cancelado correctamente...`,
                        icon: 'info'
                    });
                    await this.props.listaOrdenesCompraPorSucursal();
                }
                console.log(rpta);
            }
        } catch (error) {
            this.setState({
                loading: false,
                error: error
            });
        }
    }

    handleChangeForm = (e) => {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value,
            },
        });
    }

    handleChangeFechaEmision = (date) => {
        this.setState({
            form: {
                ...this.state.form,
                FechaEmision: date,
            },
        });
    }

    handleChangeFechaEntrega = (date) => {
        this.setState({
            form: {
                ...this.state.form,
                FechaEntrega: date,
            },
        });
    }

    formatDate = (date, formatstring) => {
        if (!date) return '';
        
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const year = d.getFullYear();
        
        switch (formatstring) {
            case 'dd-mm-yyyy':
                return `${day}-${month}-${year}`;
            case 'yyyy-mm-dd':
                return `${year}-${month}-${day}`;
            default:
                return `${month}-${day}-${year}`;
        }
    }

    handleChange_SelectSearch = (selectedOption) => {
        this.setState({
            form: {
                ...this.state.form,
                id_SelectSearch: selectedOption?.value || null,
                PrecioCosto: selectedOption?.precioCostoIgv || 0,
                IdUnidad: selectedOption?.IdUnidad || null,
                IdPresentacion: selectedOption?.IdPresentacion || null,
                IdProducto: selectedOption?.IdProducto || null
            },
            prod: selectedOption
        });
    }

    handleChangeAlmacenes = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    handleChangeCheckBox = (e) => {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.checked
            }
        }, () => {
            // Recalcular cuando cambia el checkbox de IGV
            this.recalcularTotalesSiEsNecesario();
        });
    }

    handleChangeTipoCambio = (value) => {
        this.setState({
            form: {
                ...this.state.form,
                TipoCambio: value || 0
            }
        });
    }

    handleChangePrecioCosto = (value) => {
        this.setState({
            form: {
                ...this.state.form,
                PrecioCosto: value || 0
            }
        });
    }

    handleChangeCantidad = (value) => {
        this.setState({
            form: {
                ...this.state.form,
                Cantidad: value || 0
            }
        });
    }

    handleClickRuc = async (e) => {
        e.preventDefault();
        if (this.state.form.Ruc.toString().length !== 11) {
            swal({
                title: 'Atención...! ',
                text: `Ingrese un nro de RUC válido de 11 dígitos a buscar...`,
                icon: 'error'
            });
        } else {
            await this.traerProveedor(this.state.form.Ruc);
            if (this.state.objProveedor.length === 0) {
                swal({
                    title: 'Atención...! ',
                    text: `El proveedor no existe ¿desea crear uno nuevo?`,
                    icon: 'error',
                    buttons: ['No', 'Si'],
                }).then((isConfirm) => {
                    if (isConfirm) {
                        this.handleClickNuevoProveedor();
                    }
                });
            }
        }
    }

    handleClickNuevoProveedor = () => {
        this.setState({
            form: {
                ...this.state.form,
                modalProveedorIsOpen: true,
                accion: 'NuevoProveedor'
            }
        });
    }

    handleClickBuscarProveedor = () => {
        this.setState({
            form: {
                ...this.state.form,
                modalProveedorIsOpen: true,
                accion: 'BuscarProveedor'
            }
        });
    }

    AsignarValorDoc = (dataProveedor) => {
        this.setState({
            form: {
                ...this.state.form,
                IdProveedor: dataProveedor.IdProveedor,
                Ruc: dataProveedor.Ruc,
                NomProveedor: dataProveedor.RazonSocial,
                NomContacto: dataProveedor.Contacto?.toString().toUpperCase() || '',
            },
        });
    }

    listaAlmacenes = async () => {
        this.setState({loading: true, error: null});
        try {
            const response = await fetch(`/api/almacenes/AlmacenBySucursal`);
            const data = await response.json();
            this.setState({
                loading: false,
                dataAlmacenes: data.results || [],
            });
        } catch (error) {
            this.setState({
                loading: false,
                error: error,
            });
        }
    }

    listaDetalleOC = async () => {
        this.setState({loading: true, error: null});
        const idOrden = this.props.itemordencompra.idordencompra ? 
            this.props.itemordencompra.idordencompra : this.state.form.IdOrdenCompra;
        
        if (!idOrden) {
            // Para nueva orden, calcular con array vacío
            this.calcularTotales([], this.state.form.IncluyeIGV);
            return;
        }

        try {
            const response = await fetch(`/api/ordenescompra/detalleoc/${idOrden}`);
            const data = await response.json();
            this.setState({
                loading: false,
                dataDetalleOC: data[1] || [],
            });
            // Siempre recalcular cuando cargamos el detalle
            this.calcularTotales(data[1] || [], this.state.form.IncluyeIGV);
        } catch (error) {
            this.setState({
                loading: false,
                error: error,
            });
        }
    }

    listaMonedas = async () => {
        this.setState({loading: true, error: null});
        try {
            const response = await fetch(`/api/clientes/monedas/`);
            const data = await response.json();
            this.setState({
                loading: false,
                dataMoneda: data.results || [],
            });
        } catch (error) {
            this.setState({
                loading: false,
                error: error,
            });
        }
    };

    traerProveedor = async (Ruc) => {
        this.setState({loading: true, error: null});
        try {
            const response = await fetch(`/api/proveedores/ruc/${Ruc}`);
            const data = await response.json();
            this.setState({
                loading: false,
                objProveedor: data[1] || [],
                form: {
                    ...this.state.form,
                    IdProveedor: data[1]?.[0]?.IdProveedor || null,
                    NomProveedor: data[1]?.[0]?.RazonSocial || '',
                    NomContacto: data[1]?.[0]?.Contacto || ''
                },
            });
        } catch (error) {
            this.setState({
                loading: false,
                error: error,
            });
        }
    }

    handleEliminarItem(reg) {
        swal({
            title: 'Atención...! ',
            text: `¿Desea Eliminar el item ${reg.NomProducto}?`,
            icon: 'error',
            buttons: ['No', 'Si'],
        }).then((isConfirm) => {
            if (isConfirm) {
                this.eliminarItem(reg);
            }
        });
    }

    eliminarItem = async (reg) => {
        const id = reg.IdDetalleOC;
        try {
            if (id) {
                const response = await fetch(`/api/ordenescompra/detalleoc/delete/${id}`, {
                    method: "DELETE",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    }
                });
                const rpta = await response.json();

                if (rpta) {
                    swal({
                        title: 'Atención...! ',
                        text: `Item eliminado correctamente...`,
                        icon: 'success'
                    });
                    await this.listaDetalleOC();
                }
            }
        } catch (error) {
            this.setState({
                loading: false,
                error: error
            });
        }
    }

    handleAgregarItem = async (silence = false) => {
        if (!this.state.form.IdProducto) {
            swal({
                title: 'Atención...! ',
                text: `Elija un Producto...`,
                icon: 'error'
            });
            return;
        }

        if (parseFloat(this.state.form.Cantidad) <= 0 || parseFloat(this.state.form.PrecioCosto) <= 0) {
            swal({
                title: 'Atención...! ',
                text: `Verifique valores de Precio y Cantidad...`,
                icon: 'error'
            });
            return;
        }

        try {
            const config = {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    IdDetalleOC: "1",
                    IdOrdenCompra: this.state.form.IdOrdenCompra,
                    IdProducto: this.state.form.IdProducto,
                    PrecioReferencial: this.state.form.PrecioCosto,
                    Cantidad: this.state.form.Cantidad,
                    IdPresentacion: this.state.form.IdPresentacion,
                    Total: parseFloat(this.state.form.PrecioCosto) * parseFloat(this.state.form.Cantidad),
                    IdUnidad: this.state.form.IdUnidad
                })
            };
            
            const response = await fetch(`/api/ordenescompra/detalleoc/add/`, config);
            const rpta = await response.json();
            
            if (rpta[0]?.[0]?.[0]?.estado === 'Insertado') {
                await this.listaDetalleOC();
                this.setState({ prod: null });

                if (!silence) {
                    swal({
                        title: 'Atención...! ',
                        text: `Item agregado con éxito...`,
                        icon: 'success'
                    });
                }
            } else if (rpta[0]?.[0]?.[0]?.estado === 'Duplicado') {
                swal({
                    title: 'Atención...! ',
                    text: `El item elegido ya está en lista...`,
                    icon: 'error'
                });
            }
        } catch (error) {
            this.setState({
                loading: false,
                error: error,
            });
        }
    };

    handleCloseModalProv = () => {
        this.setState({
            form: {
                ...this.state.form,
                modalProveedorIsOpen: false,
            }
        });
    }

    render() {
        return (
            <OrdenCompraForm
                accion={this.props.accion}
                handleCloseModalOC={this.props.onClose}
                handleCloseModalProv={this.handleCloseModalProv}
                form={this.state.form}
                data={this.state.data}
                dataAlmacenes={this.state.dataAlmacenes}
                dataMoneda={this.state.dataMoneda}
                objProveedor={this.state.objProveedor}
                dataDetalleOC={this.state.dataDetalleOC}
                prod={this.state.prod}
                handleChangeForm={this.handleChangeForm}
                handleChangeFechaEmision={this.handleChangeFechaEmision}
                handleChangeFechaEntrega={this.handleChangeFechaEntrega}
                handleChange_SelectSearch={this.handleChange_SelectSearch}
                handleChangeAlmacenes={this.handleChangeAlmacenes}
                handleChangeCheckBox={this.handleChangeCheckBox}
                handleChangeTipoCambio={this.handleChangeTipoCambio}
                handleChangePrecioCosto={this.handleChangePrecioCosto}
                handleChangeCantidad={this.handleChangeCantidad}
                handleSubmit={this.handleSubmit}
                handleClickRuc={this.handleClickRuc}
                handleClickNuevoProveedor={this.handleClickNuevoProveedor}
                handleClickBuscarProveedor={this.handleClickBuscarProveedor}
                AsignarValorDoc={this.AsignarValorDoc}
                listaAlmacenes={this.listaAlmacenes}
                listaDetalleOC={this.listaDetalleOC}
                listaMonedas={this.listaMonedas}
                traerProveedor={this.traerProveedor}
                handleEliminarItem={this.handleEliminarItem}
                handleAgregarItem={this.handleAgregarItem}
            />
        );
    }
}

export default OrdenCompraEditar;